import { render, staticRenderFns } from "./NhlPlayerTrends.vue?vue&type=template&id=4e012620&scoped=true"
import script from "./NhlPlayerTrends.vue?vue&type=script&lang=js"
export * from "./NhlPlayerTrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e012620",
  null
  
)

export default component.exports